import React, { useContext, useEffect, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Box from "@mui/material/Box";
import {MenuBoxStyles, InputEditStyles, BoardActionsStyles, BoardGroupCounter} from "./DistrictInsight.styles";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import BoardBuilder from "../../../components/organisms/BoardBuilder/BoardBuilder";
import {DistrictInsightContext, TokenContext} from "../../../utils/Context";
import {buildOnLoad, fetchData, localHour, nameValidation} from "../../../utils/helpsers";
import useQuery from "../../../utils/userLocation";
import {useNavigate} from "react-router-dom";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SaveBoardForm from "../../../components/molecules/SaveBoard/SaveBoardForm";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import GroupDisplay from "../../../components/molecules/GroupDisplay/GroupDisplay";

function BoardMenu({activeBoardData}) {
  // User session metadata and data
  const { user } = useAuth0();
  const metadata = user[`${process.env.REACT_APP_AUTH0_KEY}/district`];
  const enabledShare = metadata.enable_share;

  // User session token
  const {userToken} = useContext(TokenContext);

  // Query to get the Shared parameter.
  const query = useQuery();
  const navigate = useNavigate();

  const {districtInsightData, setDistrictInsightData} = useContext(DistrictInsightContext);
  const [groupCount, setGroupCount] = useState();

  /*--------------- */
  const [existingBoard, setExistingBoard] = useState();

  const [btnFilter, setBtnFilter] = useState(null);
  const [btnSave, setBtnSave] = useState(null);
  const [btnShared, setBtnShared] = useState(null);

  // Share with users hook.
  const [activeUser, setActiveUser] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersFormat, setUsersFormat] = useState([]);
  const [shareWith, setShareWith] = useState([]);
  const [userGroups, setUserGroups] = useState([]);

  // Edit board name/version.
  const [action, setAction] = useState();
  const boardName = useRef('');
  const boardVersion = useRef('');
  const [activeVersion, setActiveVersion] = useState(null);
  const [sortedVersions, setSortedVersions] = useState([]);
  const [lastVersion, setLastVersion] = useState(null);

  // Boards saved by the user.
  const [boardsName, setBoardsName] = useState(null);
  const [getUserBoards, setGetUserBoards] = useState(false)

  // Status report message.
  const [status, setStatus] = useState();
  const [displayStatus, setDisplayStatus] = useState(false);

  // If a saved board is loaded.
  useEffect(()=> {
    const abortController = new AbortController();
    if (query.get('shared')) {
      fetchData({
        endpoint: `${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${query.get('shared')}`,
        controller: abortController,
      }).then( response => {
        let boardRetrieved = response.data[0];
        // Validation if current user can access to the board data.
        if ((boardRetrieved.available_users_share && boardRetrieved.available_users_share.some(userShare => userShare.value === user.email)) || boardRetrieved.created_by === user.email) {
          let boardVersions = boardRetrieved.data;
          // Changing key created_at string to date object
          Object.keys(boardVersions).forEach(key => {
            return boardVersions[key].created_at = new Date(boardVersions[key].created_at);
          });

          // Sorted board version by date
          let versionsOrderedByDate ={};
          Object.keys(boardVersions).sort(function(a,b){
            return boardVersions[b].created_at - boardVersions[a].created_at
          }).forEach(function(key) {
            versionsOrderedByDate[key] = boardVersions[key]
          })

          // Rewriting board version with a new object ordered by date.
          boardRetrieved.data = versionsOrderedByDate;

          // set last version
          let lastVersion = Object.values(versionsOrderedByDate)[0]
          setDistrictInsightData(lastVersion)
          setExistingBoard(boardRetrieved)
          boardName.current = boardRetrieved.label
        } else {
          navigate("/AccessDenied", { replace: true });
        }
      })
    }
    // Build board on load if no query found.
    if(!query.get('shared') && userToken) {
      // Cleaning existing board data if no query detected.
      setExistingBoard()
      setLastVersion()
      buildOnLoad({user: user, callback: setDistrictInsightData, token: userToken});
    }
    //aborts the request when the component unmounts
    return () => abortController?.abort();
  },[navigate, query, setDistrictInsightData, user, userToken])

  useEffect(() => {
    if (!lastVersion && existingBoard) {
      let unsorted = Object.keys(existingBoard.data);
      unsorted = unsorted.map(version => {
            let label = version === existingBoard.data[version]['created_at'] ? `${localHour(version)}` : `${version} - ${localHour(existingBoard.data[version]['created_at'])}`;
            return { 'label': label, 'value': version, "datetime": new Date(existingBoard.data[version]['created_at']) }
          }
      );

      let sortedDates = unsorted.sort((a, b) => b.datetime - a.datetime);
      let lastVersion = sortedDates[0];

      setSortedVersions(sortedDates);
      setActiveVersion(lastVersion);
      if (lastVersion) {
        boardVersion.current = lastVersion.value;
      }
      setLastVersion(lastVersion);
    }
  }, [existingBoard, lastVersion]);

  // Using IRN string to get group count.
  useEffect(()=> {
    if(districtInsightData?.irns) {
      let irnsToString = (districtInsightData.irns).toString()
      let irnsSplit = irnsToString.split(',')
      let count = irnsSplit.length;
      setGroupCount(count);
    }
  },[districtInsightData])


  // Get available users to share board
  /** TODO  check if is possible a fn refactor to reduce the logic on this effect */
  useEffect(() => {
    if (usersFormat.length === 0 && userToken) {
      async function getGroups() {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/groups`,
            {
              headers: {
                'ngrok-skip-browser-warning': true
              }
            }
        );
        return response.data;
      }

      getGroups().then( groups => {
        setUserGroups(groups);
        axios.get(`${process.env.REACT_APP_API_URL}/users`, {
          headers: {
            'ngrok-skip-browser-warning': true
          }
        }).then(res => {
          setUsers(res.data);

          let currentUser = res.data.find((element, index) => {
            let valid = false;

            if (element.email === user.email) {
              valid = true;
            }

            return valid;
          });

          setActiveUser(currentUser);
        });

        let filteredUsers = users.filter((userF) => userF.group_id === activeUser.group_id ? userF : false);
        let usersFormatted = filteredUsers.map( (userF) => {
          let userGroup = userGroups.find(userGroup => userGroup.id === userF.group_id);
          let filteredResult = null;
          if (userF && userGroup) {
            filteredResult = { 'value': userF.email, 'label': userF.name + ' @ ' + userGroup.name };
          }
          return filteredResult;
        });
        setUsersFormat(usersFormatted);
      });
    }
  }, [activeUser.group_id, user.email, userGroups, users, usersFormat.length, userToken]);


  // Getting the boards  created by the current user.
  useEffect(() => {
    if(userToken && getUserBoards) {
      axios.get(
          `${process.env.REACT_APP_API_URL}/custom_boards?created_by=eq.${encodeURIComponent(user.email)}`,
          {
            headers: {
              'ngrok-skip-browser-warning': true
            }
          }
      ).then((res) => {
        setGetUserBoards(false)
        setBoardsName(res.data);
      });
    }
  }, [user.email, userToken, getUserBoards]);


  // Functions to control Filters menu open/close behavior.
  const openFilters = Boolean(btnFilter);
  const clickFilters = (event) => {
    setBtnFilter(event.currentTarget);
  };
  const closeFilters = () => {
    setBtnFilter(null);
  };
  const handleFilter = () => {
    setBtnFilter(null)
    setDistrictInsightData(null)
  }

  // Functions to control Save menu open/close behavior.
  const openSave = Boolean(btnSave);
  const clickSave = (event) => {
    setBtnSave(event.currentTarget);
  };
  const closeSave = () => {
    setBtnSave(null);
  };

  // Functions to control Share menu open/close behavior.
  const openShared = Boolean(btnShared);
  const clickShared = (event) => {
    setBtnShared(event.currentTarget);
  };
  const closeShared = () => {
    setBtnShared(null);
  };

  const shareWithUsers = () => {
    if (existingBoard) {
      if (shareWith.length === 0) {
        setDisplayStatus(true);
        setStatus({
          type: 'error',
          message: "Please select at least one user to share with"
        });
        closeShared();
      } else {
        let uuid = existingBoard.uuid;
        let bodyJson = existingBoard;

        bodyJson["available_users_share"] = shareWith;
        bodyJson = JSON.stringify(bodyJson);

        fetch(`${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${uuid}`, {
              method: "PUT",
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
                "Content-Type": "application/json",
              },
              body: bodyJson,
            }
        ).then((response) => {
          setDisplayStatus(true);
          setStatus({
            type: 'success',
            message: 'Board shared successfully'
          });
          closeShared();
        }).catch( err => {
          setDisplayStatus(true);
          setStatus({
            type: 'error',
            message: err.message
          });
        });
      }
    }
  };

  const changeName = (e) => {
    e.preventDefault()
    let isValidName = nameValidation({arr: boardsName, name: boardName.current, key:'label'});

    if (existingBoard && isValidName) {
      let uuid = existingBoard.uuid;
      let bodyJson = existingBoard;

      bodyJson.label = boardName.current;
      bodyJson = JSON.stringify(bodyJson);
      axios(`${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${uuid}`, {
        method: "PUT",
        headers: {
          "ngrok-skip-browser-warning": true,
          Authorization: "Bearer " + userToken,
          "Content-Type": "application/json",
        },
        data: bodyJson,
        }
      ).then(() => {
        setAction("");
        setGetUserBoards(true);
        setDisplayStatus(true);
        setStatus({
          type: 'success',
          message: 'The New Board was successfully renamed'
        });
      }).catch( err => {
        setDisplayStatus(true);
        setStatus({
          type: 'error',
          message: err.message
        });
      });
    } else if(!isValidName) {
      setDisplayStatus(true);
      setStatus({
        type: 'error',
        message: 'Board name is already in use'
      });
    }
  };

  const handleChange = (selection) => {
    if (selection !== null) {
      setDistrictInsightData(null);
      if (existingBoard) {
        setActiveVersion(selection);
        boardVersion.current = selection.value;
        // Time required to clean the insightBoard data context before update.
        setTimeout(()=>setDistrictInsightData(existingBoard.data[selection.value]), 1000)
      }
    }
  };

  const changeVersion = (e) => {
    e.preventDefault();
    let isValidName = nameValidation({arr: sortedVersions, name: boardVersion.current, key:'value'});

    if(existingBoard && isValidName) {
      let uuid = existingBoard.uuid;
      let bodyJson = existingBoard;

      if (action === 'edit-version' && existingBoard.data[activeVersion.value]['done_by'] === user.email) {
        bodyJson.data[boardVersion.current] = bodyJson.data[activeVersion.value];
        if (boardVersion.current !== activeVersion.value) {
          delete bodyJson.data[activeVersion.value];
        }
      }

      bodyJson = JSON.stringify(bodyJson);

      axios(`${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${uuid}`, {
        method: 'PUT',
        headers: {
          'ngrok-skip-browser-warning': true,
          'Authorization': 'Bearer ' + userToken,
          'Content-Type': 'application/json',
        },
        data: bodyJson
      }).then(() => {
        setDisplayStatus(true);
        setStatus({
          type: 'success',
          message: 'The Board Version was successfully renamed'
        });
        setTimeout(() => window.location.reload(), 1000);
      }).catch( err => {
        setDisplayStatus(true);
        setStatus({
          type: 'error',
          message: err.message
        });
      })
    } else if (!isValidName) {
      setDisplayStatus(true);
      setStatus({
        type: 'error',
        message: 'Version name is already in use'
      });
    }
  }

  // Stored current data in the board.
  let currentBoardData = {
    ...districtInsightData,
    comparisonCards: activeBoardData.current
  }

  return (
    <Box className={"board-actions"} sx={BoardActionsStyles}>
      <Grid container className={"board-actions__wrapper"} spacing={2}>
        <Grid item xs={12} lg={3} className={"board-actions__board-menu"} display="flex">
          <Tooltip title="Filters">
            <Button
              id="boardFilters"
              aria-controls={"menu-filters"}
              aria-haspopup="true"
              aria-expanded={openFilters ? "true" : "false"}
              variant="contained"
              onClick={clickFilters}
              color={"grape"}
              className="board-menu__filters"
            >
              <FilterAltOutlinedIcon />
              Filters
            </Button>
          </Tooltip>
          <Menu
            id="menuFilters"
            MenuListProps={{
              "aria-labelledby": "button-filters",
            }}
            anchorEl={btnFilter}
            open={openFilters}
            onClose={closeFilters}
            sx={MenuBoxStyles}
          >
            <MenuItem disableRipple>
              <BoardBuilder
                groupEnabled={true}
                yearEnabled={true}
                boardData={setDistrictInsightData}
                onSubmit={handleFilter}
                existingBoard={existingBoard}
              />
            </MenuItem>
          </Menu>
          { enabledShare && (
            <>
              <Tooltip title="Save Board">
                <span>
                  <Button
                    id="saveBoard"
                    aria-controls={"menu-save"}
                    aria-haspopup="true"
                    aria-expanded={openSave ? "true" : "false"}
                    variant="outlined"
                    color="purple"
                    disabled={!districtInsightData}
                    onClick={clickSave}
                    className={"board-menu__save-board"}
                  >
                    <SaveOutlinedIcon/>
                  </Button>
                </span>
              </Tooltip>
              <Menu
                id="menuSave"
                MenuListProps={{
                  "aria-labelledby": "button-save",
                }}
                anchorEl={btnSave}
                open={openSave}
                onClose={closeSave}
                sx={MenuBoxStyles}
              >
                <MenuItem disableRipple>
                  { districtInsightData && (
                    <SaveBoardForm
                      type={"insights"}
                      boardData={{
                        ...currentBoardData
                      }}
                      endpoint={`${process.env.REACT_APP_API_URL}/custom_boards`}
                      //layout={true}
                      customBoard={existingBoard}
                      //onChange={setExistingBoardVars}
                      onSave={closeSave}
                    />
                  )}
                </MenuItem>
              </Menu>
              <Tooltip title="Share Board">
                  <span>
                    <Button
                        id="shareBoard"
                        aria-controls={"menu-shared"}
                        aria-haspopup="true"
                        aria-expanded={openShared ? "true" : "false"}
                        variant="outlined"
                        color="purple"
                        disabled={
                          !existingBoard ||
                          existingBoard.created_by !== user.email
                        }
                        onClick={clickShared}
                        className={"share-board"}
                    >
                    <ShareOutlinedIcon/>
                  </Button>
                  </span>
              </Tooltip>
              <Menu
                id="menuShared"
                MenuListProps={{
                  "aria-labelledby": "button-shared",
                }}
                anchorEl={btnShared}
                open={openShared}
                onClose={closeShared}
                sx={MenuBoxStyles}
              >
                <MenuItem disableRipple>
                  { usersFormat && (
                      <Grid container spacing={2} textAlign="center">
                        <Grid item sm={12} display="flex">
                          <Autocomplete
                            sx={{
                              '& .MuiAutocomplete-tag': {
                                backgroundColor: '#808080',
                                color: "#ffffff"
                              },
                            }}
                            multiple
                            options={usersFormat}
                            id={"shared-with"}
                            noOptionsText={'Loading...'}
                            fullWidth
                            defaultValue={shareWith}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            onChange={(e, newValue) => {
                              setShareWith(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                  {...params}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item sm={12} display="flex">
                          <Button
                              variant="contained"
                              color="grape"
                              onClick={shareWithUsers}
                              className="share-with-users"
                          >
                            Share with users
                          </Button>
                        </Grid>
                      </Grid>
                  )}
                </MenuItem>
              </Menu>
            </>
          )}
        </Grid>
        { existingBoard && (
          <>
            <Grid item display="flex" className="board-actions__board-name" xs={12} md={6} lg={4}>
              { action === "edit-name" ? (
                <Grid item container component={"form"} spacing={0.5} xs={12} display={"flex"} onSubmit={changeName}>
                  <Grid item xs={10} className="board-name--edit">
                    <TextField
                        autoComplete="off"
                        className="form-field form-field--group-name"
                        id="BoardName"
                        defaultValue={boardName.current}
                        onChange={(e) => (boardName.current = e.target.value.trim())}
                        fullWidth
                        variant="outlined"
                        label="Board Name"
                        required
                        sx={InputEditStyles}
                        inputProps={{
                          minLength: 3,
                          pattern: "^[^\\s](?:(?!\\s{2,}).)*[^\\s]$",
                          title: "Board name must start and end with a letter or number, and can't contain consecutive spaces"
                        }}
                    />
                  </Grid>
                  <Grid item className="board__edit-actions" xs={2}>
                    <Button
                        variant="contained"
                        size="small"
                        color="grape"
                        className={"button-rename"}
                        type={"submit"}
                    >
                      Rename
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        color="secondary"
                        onClick={() => setAction("")}
                        className={"button-cancel"}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Grid item className="board-name" xs={10}>
                    <label className="board-name__label">Board Name</label>
                    {existingBoard.label}
                  </Grid>
                  <Grid className="button-edit" item xs={2}>
                    <Button
                      aria-label="edit name"
                      className="edit-name"
                      onClick={() => {
                        // On edit name, request boards data
                        setGetUserBoards(true)
                        boardName.current = existingBoard.label;
                        setAction("edit-name");
                      }}
                    >
                      <EditIcon style={{ color: "#221349" }} />
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item display="flex" className="board-actions__board-version" xs={12} md={6} lg={5}>
              { action === "edit-version" && activeVersion ? (
                  <Grid item container component={"form"} spacing={0.5} xs={12} display={"flex"} onSubmit={changeVersion}>
                    <Grid item xs={10} className="board-version--edit">
                      <TextField
                          autoComplete="off"
                          className="form-field form-field--group-name"
                          id="VersionName"
                          defaultValue={boardVersion.current}
                          onChange={(e) => boardVersion.current = e.target.value.trim()}
                          fullWidth
                          variant="outlined"
                          label="Version Name"
                          required
                          sx={InputEditStyles}
                          inputProps={{
                            minLength: 3,
                            pattern: "^[^\\s](?:(?!\\s{2,}).)*[^\\s]$",
                            title: "Version name must start and end with a letter or number, and can't contain consecutive spaces"
                          }}
                      />
                    </Grid>
                    <Grid item xs={2} className="board__edit-actions">
                      <Button
                          className="button-rename"
                          variant="contained"
                          size="small"
                          color="grape"
                          type={"submit"}
                      >
                        Rename
                      </Button>
                      <Button
                          className="button-cancel"
                          variant="contained"
                          size="small"
                          color="secondary"
                          onClick={() => setAction("")}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
              ) : (
                (activeVersion && existingBoard.data[activeVersion.value] && existingBoard.data[activeVersion.value]["done_by"] === user.email) && (
                  <>
                    <Grid item xs={10}>
                      <Autocomplete
                          id="data-version"
                          options={sortedVersions}
                          onChange={(e, newValue) => {
                            if(newValue) {
                              handleChange(newValue);
                            }
                          }}
                          defaultValue={activeVersion}
                          noOptionsText={'Loading...'}
                          renderInput={(params) => (<TextField{...params} label="Board version" />
                          )}
                      />
                    </Grid>
                    <Grid item xs={2} className={"button-edit"}>
                      <Button
                          aria-label="edit version"
                          size="large"
                          className={"edit-version"}
                          onClick={() => {
                            setAction("edit-version");
                            boardVersion.current = activeVersion.value;
                          }}
                      >
                        <EditIcon style={{ color: "#221349" }} />
                      </Button>
                    </Grid>
                  </>
                )
              )}
            </Grid>
          </>
        )}
        { (districtInsightData && groupCount) && (
            <Grid item xs={12} lg={existingBoard ? 12 : 9} className="group-counter" sx={BoardGroupCounter}>
              <div className="group-counter__wrapper">
                <div className="group-counter__versus">{`${districtInsightData.referenceDistrict.label} - vs -`} <GroupDisplay groupData={districtInsightData}/></div>
                <div className="group-counter__result">{`Year: ${
                  districtInsightData.year.value === "MCD"
                    ? `2026 (${districtInsightData.year.label})`
                    : districtInsightData.year.label
                } | ${groupCount} districts in the comparison group.`}</div>
              </div>
            </Grid>
        )}
      </Grid>
      <Snackbar
          className="statusMessage"
          open={displayStatus}
          autoHideDuration={6000}
          onClose={() => setDisplayStatus(false)}>
        <Alert onClose={() => setDisplayStatus(false)} variant="filled" severity={`${status?.type ?? 'success'}`}>{status?.message}</Alert>
      </Snackbar>
    </Box>
  )
}

export default React.memo(BoardMenu)
